<template>
    <div>
      <v-card>
        <v-toolbar dense dark flat color="primary">
          <v-toolbar-title>
            <span>Buscar por</span>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-form ref="form" v-model="isFormValid" lazy-validation>
            <v-row dense>
              <v-col cols="12" md="6">
                <!-- new -->
                <v-text-field
                  v-model="form.poliza" 
                  label="Certificado"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.emision_id"
                  label="ID Poliza"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="form.status"
                  label="Estatus Solicitud"
                  :items="emisionesStatus"
                  item-text="title"
                  item-value="id"
                  outlined
                  dense
                ></v-select>
              </v-col>
              
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="form.nombre"
                  label="Nombre"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.apellidoPaterno"
                  label="Apellido Paterno"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.apellidoMaterno"
                  label="Apellido Materno"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
              <v-text-field
                v-model="form.fecha_nacimiento"
                outlined
                dense
                label="Fecha de nacimiento"
                type="date"
              ></v-text-field>
            </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.rfc"
                  label="RFC"
                  outlined
                  dense
                  :rules="[$rules.rfc]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="form.telefono"
                  label="Teléfono"
                  outlined
                  dense
                  prepend-inner-icon="mdi-phone"
                  maxLength="10"
                  counter
                  :rules="[$rules.numeric, localRules.longDigit(10)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="12">
                <v-text-field
                  v-model="form.correo"
                  label="Correo electrónico"
                  outlined
                  dense
                  prepend-inner-icon="mdi-email"
                  :rules="[$rules.email]"
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
              <v-autocomplete
                v-model="form.producto_aseguradora"
                outlined
                :items="productos_aseguradora"
                dense
                required
                label="Producto Aseguradora"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="6"
              v-if="form.producto_aseguradora == 'Asistencias'"
            >
              <v-text-field
                v-model="form.tarjeta"
                outlined
                dense
                counter="16"
                :maxLength="16"
                :rules="[$rules.numeric, localRules.longDigit(16)]"
                label="Tarjeta"
              ></v-text-field>
            </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            :disabled="!isFormValid || !minimoUnCampoLleno"
            :loading="loading"
            @click="updateSearch"
          >
            <v-icon small class="mr-2">mdi-magnify</v-icon>
            <span>Buscar</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="minimoUnCampoLleno" text @click="clearForm()"
            >Limpiar filtros</v-btn
          >
        </v-card-actions>
      </v-card>
    </div>
  </template>
  
  <script>
   import { mainAxios } from "../../mainAxios";
   import moment from "moment";
   const requestConfig = {
     headers: {
       Authorization: "Bearer " + localStorage.agenteAccessToken,
     },
   };
  export default {
    props: {
      currentFilters: {
        type: Object,
        default: () => {},
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        form: {
          poliza: "",
          status: "",
          agente_id: "",
          operador_id: "",
          ramo: "",
          rango_fechas: "",
          tipo: "",
          nombre: "",
          apellidoPaterno: "",
          apellidoMaterno: "",
          rfc: "",
          telefono: "",
          correo: "",
          producto_aseguradora: "",
          tarjeta: "",
          certificado: "",
          fecha_nacimiento: "",
          emision_id: ""
        },
        menuFecha: false,
        emisionesStatus: [
          {
            id: 0,
            title: "Nueva",
          },
          {
            id: 1,
            title: "Emitida Pendente de Pago",
          },
          {
            id: 2,
            title: "Pagada Parcial",
          },
          {
            id: 3,
            title: "Pagada Total",
          },
          {
            id: 4,
            title: "Renovada",
          },
          {
            id: 5,
            title: "Finalizada",
          },
          {
            id: 6,
            title: "Cancelada",
          },
          {
            id: 8,
            title: "Emitido el certificado",
          },
        ],
        ramos: [],
        tipos: [
          "Cotización",
          "Emisión",
          "Renovación",
          "Endoso A y D",
          "Endoso B",
          "Facturacion",
          "Cancelación",
          "Otro",
        ],
        isFormValid: true,
        localRules: {
          longDigit(number) {
            return (v) =>
              !v ||
              v.length == number ||
              "Debe proporcionar " + number + " digitos";
          },
        },
        productos_aseguradora: [],
      };
    },
    computed: {
    datesSelectedString() {
      if (this.form.rango_fechas.length > 1)
        return `${this.formatDate(
          this.form.rango_fechas[0]
        )} a ${this.formatDate(this.form.rango_fechas[1])}`;
      return "";
    },
    minimoUnCampoLleno() {
      return (
        Object.keys(this.form).filter(
          (e) => !!this.form[e] || this.form[e] === 0
        ).length >= 1
      );
    },
  },          
    watch: {
    currentFilters(v) {
        !!v && this.setCurrent();
      },
    },
    mounted() {
      this.setCurrent();
      this.getRamos();
      this.getProductosAseguradora();
    },
    methods: {
      getRamos() {
      mainAxios.get("/v1/ramo/list", requestConfig).then(({ data }) => {
        this.ramos = data;
      });
      },
      getProductosAseguradora() {
      mainAxios
        .get("v1/producto/productosAseguradora", requestConfig)
        .then((response) => {
          this.productos_aseguradora = response.data.data.productos;
        });
    },
      formatDate(date) {
        return moment(date).format("DD/MM/YYYY");
      },
      updateSearch() {
        if (!this.isFormValid || !this.minimoUnCampoLleno) return;
        if (!this.form.producto_aseguradora) {
        this.$toast.error("El producto aseguradora es un campo requerido");
        return;
      }
        let payload = {};
        Object.keys(this.form).forEach((e) => {
          if (!!this.form[e] || this.form[e] === 0) payload[e] = this.form[e];
        });
        this.$emit("searchUpdated", payload);
      },
      setCurrent() {
        this.clearForm();
        this.form = { ...this.form, ...this.currentFilters };
      },
      clearForm() {
        Object.keys(this.form).forEach((key) => {
          this.form[key] = "";
        });
      },
    },
  };
  </script>
  
